import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=af0a503c&scoped=true"
import script from "./learning.vue?vue&type=script&lang=js"
export * from "./learning.vue?vue&type=script&lang=js"
import style0 from "./learning.vue?vue&type=style&index=0&id=af0a503c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0a503c",
  null
  
)

export default component.exports